// extracted by mini-css-extract-plugin
export default {"section":"Bottom_section__WPtFs","title":"Bottom_title__Pi3qe","mint":"Bottom_mint__8XFvo"};